import { makeStyles } from "@material-ui/core/styles";
const drawerWidth = 240;

const theme = (props) => {
  const styles = makeStyles(theme => ({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerContainer: {
      marginTop: 60,
      overflow: 'auto',
      height: 'calc(100vh - 60px)',
      display: 'flex',
      flexDirection: 'column',
      '& .MuiTypography-body1':{
        fontSize:'13px !important',
        fontWeight:'200 !important',
        textTransform:'uppercase',
        lineHeight:'24px'
      },
      '& svg': {
        fill: '#919191',
        fontSize: 19
      },
      '& img': {
        maxHeight: 19,
        maxWidth: 19,
      },
      '& ul': {
        padding: 0,
      },
      '& .MuiListItemIcon-root': { minWidth: 30 },
      '& .MuiListItem-button:hover': { background: '#ddd' },

      '& .MuiListItem-root': {
        paddingTop: 4,
        paddingBottom: 4,
      },
    },
    selectedMain: {
      background: 'grey !important',
      color: 'white',
      '& svg': {
        fill: 'white',
      },

    },
    selectedNested: {
      background: 'darkgrey !important',
      color: 'white',
    },
    selected: {
      background: 'grey !important',
      color: 'white',
      '& svg': {
        fill: 'white',
      },
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },

    bottomMenu: {
      marginTop: 'auto',
      borderTop: '1px solid #ddd',
    },

    n8nButton: {
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: 240,
      zIndex: 1400,
      borderTop: '1px solid #ddd',
      background: '#fff',
      transition: 'transform 200ms ease',
    },
    n8nButtonOpen: {
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: 240,
      zIndex: 1400,
      borderTop: '1px solid #ddd',
      background: '#fff',
      transform: 'translateY(-50vh)',
      transition: 'transform 200ms ease',
    },
    n8nBackdrop: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.35)',
      zIndex: 1300,
    },
    n8nSheet: {
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      height: '50vh',
      maxHeight: 'calc(100vh - 60px)',
      background: '#fff',
      zIndex: 1350,
      transform: 'translateY(100%)',
      transition: 'transform 200ms ease',
      overflow: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    n8nSheetOpen: {
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      height: '50vh',
      maxHeight: 'calc(100vh - 60px)',
      background: '#fff',
      zIndex: 1350,
      transform: 'translateY(0)',
      transition: 'transform 200ms ease',
      overflow: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },

    n8nSheetHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      padding: `${theme.spacing(1.25)}px ${theme.spacing(2)}px ${theme.spacing(0.75)}px`,
      borderBottom: '1px solid #e5e7eb',
      background: '#fff',
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        padding: `${theme.spacing(1)}px ${theme.spacing(1.25)}px ${theme.spacing(0.75)}px`,
      },
    },

    n8nSheetTitle: {
      fontSize: 14,
      lineHeight: '18px',
      fontWeight: 600,
      color: '#111827',
      textTransform: 'uppercase',
      letterSpacing: 0.3,
    },

    n8nRefreshButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      border: '1px solid #d1d5db',
      borderRadius: 999,
      background: '#fff',
      color: '#374151',
      padding: '6px 12px',
      fontSize: 12,
      lineHeight: '14px',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'background 150ms ease, border-color 150ms ease',
      textTransform: 'uppercase',
      '&:hover': {
        background: '#f9fafb',
        borderColor: '#9ca3af',
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'default',
      },
    },

    n8nRefreshIcon: {
      fontSize: 16,
      fill: '#374151 !important',
    },

    n8nRefreshIconSpinning: {
      fontSize: 16,
      fill: '#374151 !important',
      animation: '$n8nSpin 0.9s linear infinite',
    },

    n8nColumns: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      alignItems: 'start',
    },

    n8nColumn: {
      minWidth: 0,
      border: '1px solid #ddd',
      padding: theme.spacing(1.5),
      background: '#fafafa',
      overflow: 'auto',
    },

    n8nColumnTitle: {
      margin: `0 0 ${theme.spacing(1)}px 0`,
      fontSize: 14,
      fontWeight: 600,
    },

    n8nDashboard: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      flex: 1,
      minHeight: 0,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1.25),
      },
      '& *': {
        boxSizing: 'border-box',
      },
    },

    n8nTopRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
      gap: theme.spacing(1.5),
      alignItems: 'stretch',
      flex: 1,
      minHeight: 0,
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        flex: 'unset',
      },
    },

    n8nTopRowWithError: {
      gridTemplateColumns: 'minmax(0, 0.9fr) minmax(0, 1.1fr)',
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },

    n8nTopRowSingle: {
      gridTemplateColumns: '1fr',
    },

    n8nTopRowLongFailure: {
      gridTemplateColumns: '1fr',
    },

    n8nCardExpanded: {
      minHeight: 260,
    },

    n8nCardFocus: {
      minHeight: 280,
      borderColor: '#93c5fd',
    },

    n8nCard: {
      border: '0.5px solid #d1d5db',
      borderRadius: 12,
      background: '#ffffff',
      padding: theme.spacing(1.5),
      minHeight: 220,
      minWidth: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
    },

    n8nFocusHeader: {
      display: 'grid',
      gridTemplateColumns: '1.5fr 1fr 1fr auto',
      gap: theme.spacing(1),
      padding: `${theme.spacing(0.4)}px ${theme.spacing(1)}px`,
      marginTop: theme.spacing(0.25),
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },

    n8nFocusHeaderCell: {
      margin: 0,
      fontSize: 11,
      lineHeight: '13px',
      color: '#64748b',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'uppercase',
      letterSpacing: 0.3,
      fontWeight: 500,
    },

    n8nFocusRows: {
      border: '0.5px solid #dbeafe',
      borderRadius: 8,
      background: '#f8fbff',
      padding: theme.spacing(1.25),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      flex: 1,
      overflow: 'auto',
    },

    n8nFocusDataRow: {
      display: 'grid',
      gridTemplateColumns: '1.6fr 1fr 1fr auto',
      gap: theme.spacing(1),
      alignItems: 'center',
      padding: `${theme.spacing(1)}px ${theme.spacing(1.25)}px`,
      border: '0.5px solid #e5e7eb',
      borderRadius: 6,
      minHeight: 42,
      background: '#ffffff',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        alignItems: 'start',
      },
    },

    n8nFocusCellJobWrap: {
      minWidth: 0,
    },

    n8nFocusCellJob: {
      margin: 0,
      fontSize: 13,
      lineHeight: '16px',
      color: '#0f172a',
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 500,
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    n8nFocusCellRunId: {
      margin: 0,
      fontSize: 13,
      lineHeight: '16px',
      color: '#0f172a',
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 500,
      textTransform: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    n8nFocusCellTime: {
      margin: 0,
      fontSize: 13,
      lineHeight: '16px',
      color: '#0f172a',
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 500,
      textTransform: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    n8nFocusCellSub: {
      margin: '2px 0 0 0',
      fontSize: 11,
      lineHeight: '13px',
      color: '#6b7280',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    n8nCardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
      },
    },

    n8nCardTitleWrap: {
      display: 'flex',
      alignItems: 'baseline',
      gap: theme.spacing(0.75),
      minWidth: 0,
      flexWrap: 'wrap',
    },

    n8nCardTitle: {
      margin: 0,
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 500,
      color: '#111827',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },

    n8nCardSubtitle: {
      margin: 0,
      fontSize: 12,
      color: '#6b7280',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },

    n8nCountBadge: {
      minWidth: 22,
      height: 22,
      padding: '0 7px',
      borderRadius: 999,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 12,
      fontWeight: 500,
      background: '#edf2f7',
      color: '#1f2937',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },

    n8nCountBadgeError: {
      background: '#fee2e2',
      color: '#b91c1c',
    },

    n8nList: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      minWidth: 0,
      flex: 1,
      overflow: 'auto',
    },

    n8nJobRow: {
      border: '0.5px solid #e5e7eb',
      borderLeftWidth: 3,
      borderRadius: 0,
      padding: theme.spacing(1),
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) auto auto auto',
      gap: theme.spacing(1),
      alignItems: 'center',
      minWidth: 0,
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'minmax(0, 1fr) auto',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        alignItems: 'start',
      },
    },

    n8nSuccessRow: {
      borderLeftColor: '#16a34a',
      background: '#ffffff',
    },

    n8nErrorRow: {
      borderLeftColor: '#dc2626',
      background: '#fff1f2',
    },

    n8nInfoRow: {
      borderLeftColor: '#2563eb',
      background: '#ffffff',
    },

    n8nMainCol: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      gap: theme.spacing(1),
    },

    n8nStatusDot: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      flexShrink: 0,
    },

    n8nStatusDotPulse: {
      animation: '$n8nPulse 1.4s ease-in-out infinite',
    },

    '@keyframes n8nPulse': {
      '0%': { opacity: 0.3 },
      '50%': { opacity: 1 },
      '100%': { opacity: 0.3 },
    },

    '@keyframes n8nSpin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },

    n8nJobName: {
      margin: 0,
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: 13,
      lineHeight: '16px',
      fontWeight: 500,
      textTransform: 'uppercase',
      color: '#0f172a',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    n8nMeta: {
      margin: '2px 0 0 0',
      fontSize: 12,
      lineHeight: '14px',
      color: '#6b7280',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },

    n8nTimeCol: {
      textAlign: 'right',
      minWidth: 72,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
      },
    },

    n8nTime: {
      margin: 0,
      fontSize: 12,
      lineHeight: '14px',
      fontFamily: 'Helvetica, Arial, sans-serif',
      color: '#111827',
      textTransform: 'none',
    },

    n8nStatusPill: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 999,
      padding: '3px 10px',
      fontSize: 12,
      lineHeight: '14px',
      fontWeight: 500,
      minWidth: 58,
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
      justifySelf: 'end',
      [theme.breakpoints.down('sm')]: {
        justifySelf: 'start',
      },
    },

    n8nPillSuccess: {
      color: '#15803d',
      background: '#dcfce7',
    },

    n8nPillError: {
      color: '#b91c1c',
      background: '#fee2e2',
    },

    n8nPillInfo: {
      color: '#1d4ed8',
      background: '#dbeafe',
      gap: 4,
    },

    n8nChevron: {
      color: '#9ca3af',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    n8nDivider: {
      height: 1,
      background: '#e5e7eb',
      marginTop: theme.spacing(0.75),
    },

    n8nEmptyState: {
      minHeight: 140,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: theme.spacing(0.75),
      color: '#6b7280',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },

    n8nErrorBox: {
      border: '0.5px solid #fecaca',
      borderRadius: 8,
      borderLeftWidth: 3,
      borderLeftColor: '#dc2626',
      background: '#fff1f2',
      padding: theme.spacing(1.25),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.8),
      minWidth: 0,
      width: '100%',
      flex: 1,
      overflow: 'auto',
    },

    n8nErrorHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      minWidth: 0,
    },

    n8nDetailRows: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.7),
      marginTop: theme.spacing(0.25),
    },

    n8nDetailRow: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(0.8),
      padding: `${theme.spacing(0.4)}px 0`,
    },

    n8nDetailIconWrap: {
      width: 18,
      height: 18,
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 1,
    },

    n8nDetailIcon: {
      fontSize: 14,
      color: '#b91c1c',
      fill: '#b91c1c !important',
    },

    n8nDetailText: {
      margin: 0,
      fontSize: 12,
      lineHeight: '16px',
      color: '#374151',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
      wordBreak: 'break-word',
      '& strong': {
        fontWeight: 500,
        color: '#111827',
      },
    },

    n8nErrorIcon: {
      width: 22,
      height: 22,
      borderRadius: '50%',
      background: '#dc2626',
      color: '#fff',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      '& svg': {
        fill: '#fff',
        fontSize: 14,
      },
    },

    n8nCode: {
      margin: 0,
      padding: theme.spacing(1),
      borderRadius: 8,
      border: '0.5px solid #fecaca',
      background: '#fffafc',
      color: '#b91c1c',
      fontFamily: 'Menlo, Monaco, Consolas, monospace',
      fontSize: 12,
      lineHeight: '16px',
      whiteSpace: 'pre-wrap',
      textTransform: 'none',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
      maxHeight: 420,
      minHeight: 20,
      overflow: 'auto',
    },

    n8nBanner: {
      width: '100%',
      border: '0.5px solid #bfdbfe',
      borderRadius: 12,
      background: '#eff6ff',
      padding: theme.spacing(1.5),
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },

    n8nBannerTitle: {
      margin: 0,
      fontSize: 15,
      lineHeight: '18px',
      fontWeight: 500,
      color: '#1e3a8a',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      textTransform: 'none',
    },

    n8nBannerText: {
      margin: `${theme.spacing(0.5)}px 0 0 0`,
      fontSize: 12,
      lineHeight: '16px',
      color: '#64748b',
      textTransform: 'none',
    },

    n8nBannerActive: {
      borderColor: '#93c5fd',
      background: '#ffffff',
    },
    errorStatusIcon: {
      fill: "#dc2626 !important"
    },
    successStatusIcon: {
      fill: "#16a34a !important"
    },
    n8nUnavailable: {
      flex: 1,
      minHeight: 260,
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1.5),
      textAlign: 'center',
    },

    n8nUnavailableIcon: {
      fontSize: '48px !important',
      fill: '#dc2626 !important',
    },

    n8nUnavailableMessage: {
      color: '#4b5563',
      marginBottom: "8px"
    },

    n8nUnavailableDetails: {
      maxWidth: 560,
      color: '#991b1b',
      fontSize: 12,
      overflowWrap: 'anywhere',
    },
  }));
  return styles();
}
export default theme;

